/* eslint-disable max-len */
import {
    Box,
    Checkbox,
    Collapse,
    FormControl, FormErrorMessage, HStack, Input, Text, useDisclosure, VStack,
} from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import { SubmitBookingFormSchemaValues } from './form-scheme';

export function AddNominatedContact() {
    const {
        isOpen, onToggle,
    } = useDisclosure();
    const { control, setValue, watch } = useFormContext<SubmitBookingFormSchemaValues>();

    const handleToggle = () => {
        onToggle();
        setValue('oasBooking.nominatedContact.isEnabled', !isOpen);
    };

    const { isEnabled } = watch('oasBooking.nominatedContact');

    return (
        <>
            <Box isChecked={isEnabled} as={Checkbox} onChange={handleToggle}>
                <Text fontSize="sm">
                    Click here to include a nominated contact for this
                    booking other than the occupants listed above.
                </Text>
            </Box>

            <Collapse in={isOpen}>
                <VStack p={6} pt={4} pb={1} gap={4}>
                    <Text color="muted.500" fontSize="sm" w="full">
                        This contact will be the primary contact for this booking.
                    </Text>

                    <Controller
                        control={control}
                        name="oasBooking.nominatedContact.name"
                        render={({ fieldState, field }) => (
                            <FormControl isInvalid={fieldState.invalid}>
                                <Input {...field} placeholder="Full Name" />

                                {fieldState.error && (
                                    <FormErrorMessage>
                                        {fieldState.error.message}
                                    </FormErrorMessage>
                                )}
                            </FormControl>
                        )}
                    />

                    <HStack w="full" gap={4} alignItems="start">
                        <Controller
                            control={control}
                            name="oasBooking.nominatedContact.email"
                            render={({ fieldState, field }) => (
                                <FormControl isInvalid={fieldState.invalid}>
                                    <Box w="full">
                                        <Input {...field} type="email" placeholder="Email" />

                                        {fieldState.error && (
                                            <FormErrorMessage>
                                                {fieldState.error.message}
                                            </FormErrorMessage>
                                        )}
                                    </Box>
                                </FormControl>
                            )}
                        />

                        <Controller
                            control={control}
                            name="oasBooking.nominatedContact.mobile"
                            render={({ fieldState, field }) => (
                                <FormControl isInvalid={fieldState.invalid}>
                                    <Input {...field} placeholder="Mobile" />

                                    {fieldState.error && (
                                        <FormErrorMessage>
                                            {fieldState.error.message}
                                        </FormErrorMessage>
                                    )}
                                </FormControl>
                            )}
                        />
                    </HStack>
                </VStack>
            </Collapse>
        </>
    );
}
